import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferGameServiceGameVo, OfferGameServiceSpuQuery, OfferGameServiceSpuVo } from './type';

/**
 * game service offer上传/修改时查询当前卖家可卖的游戏
  GET /product/offerManage/getSellGame
  接口ID：263628561
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628561
 */
export const getGameServiceSellGame = (): AxiosPromise<OfferGameServiceGameVo[]> => {
  return request({
    url: '/product/offerManage/getSellGame',
    method: 'get'
  });
};

/**
 * game service offer上传/修改时根据游戏查询当前卖家可经营的业务
  GET /product/offerManage/getSellBusiness
  接口ID：263628562
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628562
 */
export const getGameServiceSellerBusiness = (params: OfferGameServiceSpuQuery): AxiosPromise<OfferGameServiceSpuVo[]> => {
  return request({
    url: '/product/offerManage/getSellBusiness',
    method: 'get',
    params
  });
};
